import { useState } from "react";
import { useLocation } from "wouter";
import axios from "axios";

const BASE_URL = "https://apiqtc.miscuotas.com/ms-solicitud";

const correoValido = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

export function SectionFinanciaTuMoto() {
  const [dni, setDni] = useState("");
  const [celular, setCelular] = useState("");
  const [correo, setCorreo] = useState("");
  const [oferta, setOferta] = useState(null);
  const [loading, setLoading] = useState(false);
  const [touched, setTouched] = useState({ dni: false, celular: false, correo: false });
  const [, setLocation] = useLocation();

  const touch = (field) => setTouched((t) => ({ ...t, [field]: true }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (celular.length !== 9) return;
    setLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/solicitud/generar-con-digimedia`,
        {
          payload: {
            nroDocumento: dni,
            tipoDocumento: "DNI",
            celular,
            correo,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            idUsuario: "EVALUACION",
          },
        }
      );
      console.log("generar-con-digimedia response:", response.data);
      if (response.data.status?.success) {
        setOferta({
          title: "Tienes una oferta disponible",
          body: (
            <>
              Acércate a nuestro vendedor o punto de atención para conocer las motos disponibles y continuar con tu evaluación.
              <br/><br/>
              Te esperamos para ayudarte a estrenar tu nuevo moto.
            </>
          ),
          image: "img/cono-fiesta.png",
        });
      } else {
        setOferta({
          title: "Gracias por tu interés",
          body: (
            <>
              Por el momento no contamos con una oferta disponible para ti.
              <br/><br/>
              Te invitamos a volver a intentarlo más adelante.
            </>
          ),
        });
      }
    } catch (error) {
      console.error("generar-con-digimedia error:", error);
      setOferta({
        title: "Gracias por tu interés",
        body: (
          <>
            Por el momento no contamos con una oferta disponible para ti.
            <br/><br/>
            Te invitamos a volver a intentarlo más adelante.
          </>
        ),
      });
    } finally {
      setLoading(false);
    }
  };

  const handleFinalizar = () => {
    setOferta(null);
    setLocation("/");
  };

  return (
    <section className="hero-faqs hero-financia">
      <div className="container">
        <article>
          <h2 className="hero-faqs__title"><b>FINANCIA TU MOTO</b></h2>
          <p className="hero-faqs__subtitle">
            Conoce en segundos si tienes una oferta disponible para financiar tu próxima moto.<br/><br/>
            Ingresa tus datos para iniciar tu evaluación:
          </p>
          <form className="hero-financia__form" onSubmit={handleSubmit} noValidate>
            <div className="hero-financia__row hero-financia__row--full">
              <div className="hero-financia__field">
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength={8}
                  placeholder="Ingresa tu DNI"
                  value={dni}
                  onChange={(e) => setDni(e.target.value.replace(/\D/g, ""))}
                  onBlur={() => touch("dni")}
                />
                {touched.dni && dni.length > 0 && dni.length !== 8 && (
                  <span className="hero-financia__error">El DNI debe tener 8 dígitos</span>
                )}
              </div>
            </div>
            <div className="hero-financia__row">
              <div className="hero-financia__field">
                <input
                  type="tel"
                  inputMode="numeric"
                  maxLength={9}
                  placeholder="Ingresa tu Celular"
                  value={celular}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, "");
                    if (val === "" || val.startsWith("9")) setCelular(val);
                  }}
                  onBlur={() => touch("celular")}
                />
                {touched.celular && celular.length > 0 && celular.length !== 9 && (
                  <span className="hero-financia__error">El celular debe tener 9 dígitos y empezar con 9</span>
                )}
              </div>
              <div className="hero-financia__field">
                <input
                  type="email"
                  placeholder="Ingresa tu Correo"
                  value={correo}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^a-zA-Z0-9._%+\-@]/g, "");
                    setCorreo(val);
                  }}
                  onBlur={() => touch("correo")}
                />
                {touched.correo && !correoValido(correo) && (
                  <span className="hero-financia__error">Ingresa un correo válido</span>
                )}
              </div>
            </div>
            <div className="hero-financia__row hero-financia__row--btn">
              <button
                type="submit"
                disabled={loading || dni.length !== 8 || celular.length !== 9 || !correoValido(correo)}
              >
                {loading ? "Verificando..." : "Verificar oferta"}
              </button>
            </div>
          </form>
        </article>
        <aside>
          <img src="img/financia_moto.png" alt="Moto Ofero" />
        </aside>
      </div>

      {loading && (
        <div className="oferta-overlay">
          <div className="spinner-container">
            <div className="spinner" />
          </div>
        </div>
      )}

      {oferta && (
        <div className="oferta-overlay">
          <div className="oferta-modal">
            <h3 className="oferta-modal__title">{oferta.title}</h3>
            <p className="oferta-modal__text">{oferta.body}</p>
            <button
              type="button"
              className="oferta-modal__btn"
              onClick={handleFinalizar}
            >
              Finalizar
            </button>
            {oferta.image && (
              <img
                className="oferta-modal__img"
                src={oferta.image}
                alt=""
              />
            )}
          </div>
        </div>
      )}
    </section>
  );
}
